import React, { useState } from 'react';
import { AddIcon, DeleteIcon, EditIcon, FoldDown, FoldRight } from '../../Static/icons/iconshere';
import { checkUserAllowPermissions } from '../../utils/common';
import { CONTENT_CATEGORY_CREATE } from '../../constant/Permissions';


const CategoryItem = ({ level, key, category, openModal, openEditModal, openDeleteModal }) => {
  const [showChildren, setShowChildren] = useState(false);

  return (
    <div className='cate-list' key={key}>
      <div className='parent-child'>
        <div className='child'>
          <div className='parent'>
            <span className='cate-action'>
              {category.children.length > 0 &&
                <button className='fold' onClick={() => setShowChildren(!showChildren)}>
                  {showChildren ? <FoldDown /> : <FoldRight />}
                </button>}
              {category.name}
            </span>

            {checkUserAllowPermissions(CONTENT_CATEGORY_CREATE) &&
              <span className='cate-action'>
                <button className='add-cate' onClick={() => openModal("sub.category", category.id)}>
                  <AddIcon /> Category
                </button>

                <button onClick={() => openEditModal(level === 1 ? "category" : "sub.category", category.name, category.id, category.parentId)} >
                  <EditIcon />
                </button>

                <button onClick={() => openDeleteModal(category.id)} >
                  <DeleteIcon />
                </button>

              </span>}

          </div>

          {showChildren && category.children.length > 0 && (
            <div className='children'>
              {category.children.map((child, index) => (
                <CategoryItem level={level + 1} key={child.id} category={child} openModal={openModal} openEditModal={openEditModal} openDeleteModal={openDeleteModal} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CategoryItem;